import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = 'Parth Interiors - Luxury Interior Design Services',
    description = 'Transform your space with Parth Interiors. Expert interior design services for residential, commercial, and corporate spaces. Creating timeless and innovative designs.',
    keywords = 'interior design, luxury interiors, residential design, commercial design, corporate design, space planning, custom furniture, renovation',
    image = 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6',
    url = 'https://parthinteriors.com'
}) => {
    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />

            {/* Twitter Card Meta Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Additional Meta Tags */}
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="English" />
            <meta name="author" content="Parth Interiors" />
            <meta name="theme-color" content="#2C3639" />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO; 